
import React, { ReactNode } from "react";

interface ContactSectionFormFieldProps {
  id: string;
  name: string;
  label: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  required?: boolean;
  isTextarea?: boolean;
  rows?: number;
  icon?: ReactNode;
  error?: string;
  maxLength?: number;
}

const ContactSectionFormField = ({
  id,
  name,
  label,
  type = "text",
  value,
  onChange,
  required = false,
  isTextarea = false,
  rows = 4,
  icon,
  error,
  maxLength
}: ContactSectionFormFieldProps) => {
  const inputClasses = `w-full ${icon ? 'pl-10' : 'px-4'} py-2 border ${error ? 'border-destructive' : 'border-gray-300 dark:border-gray-600'} dark:bg-gray-700 dark:text-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-primary/50`;
  
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {label}
      </label>
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
            {icon}
          </div>
        )}
        {isTextarea ? (
          <textarea
            id={id}
            name={name}
            required={required}
            value={value}
            onChange={onChange}
            rows={rows}
            maxLength={maxLength}
            className={inputClasses}
          />
        ) : (
          <input
            type={type}
            id={id}
            name={name}
            required={required}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            className={inputClasses}
          />
        )}
      </div>
      {error && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};

export default ContactSectionFormField;
